import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* v2.1 typography stack — Geist (sans) + Geist Mono. Variable-axis via
   @fontsource-variable so weight interpolates smoothly with a single file. */
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

import { Providers } from './app/providers';
import { Router } from './app/router';
import { initThemeFromStorage } from './stores/theme.store';
import './styles/globals.css';

// Apply theme BEFORE React mounts so the page never flashes the wrong palette.
initThemeFromStorage();

// After a deploy, a tab opened on the old build asks for page chunks that no
// longer exist. Reload once to pick up the new build instead of crashing.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'pp.chunk-reload-at';
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(key) ?? 0);
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // Storage blocked: reload anyway (no loop guard in that rare case).
  }
  if (Date.now() - last < 10_000) return;
  event.preventDefault();
  window.location.reload();
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>,
);
